import axios from 'axios'
import { unique } from '.'
import { UUID } from '@/types'

/**
 * Add selected elements to a corpus' dataset set
 */
export const createDatasetElementsSelection = unique(async (corpusId: UUID, setId: UUID) => (await axios.post(`/corpus/${corpusId}/datasets/selection/`, { set_id: setId })))
